import { createContext } from 'react';
import { MessagesContextType } from './types';

export const MessagesContext = createContext({} as MessagesContextType);
